// extracted by mini-css-extract-plugin
export default {"alertBar":"J2W76H5DKe"};